import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Logo: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 219.365 57.007"
    >
      <defs></defs>
      <path
        fill="currentColor"
        d="M0,36.733l5.585-5.147c.723.767,1.577,1.577,2.541,2.475a14.5,14.5,0,0,0,3.5,2.3,10.951,10.951,0,0,0,4.709.876,7.622,7.622,0,0,0,5.541-1.752,5.432,5.432,0,0,0,1.818-4.1,4.884,4.884,0,0,0-2.19-4.249,22.383,22.383,0,0,0-7.95-2.606A15.9,15.9,0,0,1,7.14,21.906a11.827,11.827,0,0,1-3.745-4.38A12.111,12.111,0,0,1,2.19,12.2a11.476,11.476,0,0,1,1.621-6,11.892,11.892,0,0,1,4.95-4.49A17.718,17.718,0,0,1,16.908,0,20.434,20.434,0,0,1,22.69.727a16.47,16.47,0,0,1,4.03,1.8A13.645,13.645,0,0,1,29.238,4.56c.591.657,1.007,1.117,1.248,1.424L25.23,10.955c-.263-.263-.767-.7-1.489-1.336a12.9,12.9,0,0,0-2.869-1.752,10.184,10.184,0,0,0-4.227-.81,6.57,6.57,0,0,0-4.862,1.708,4.6,4.6,0,0,0-1.555,3.066,4.512,4.512,0,0,0,1.818,3.658,18.529,18.529,0,0,0,7.008,2.5,23.04,23.04,0,0,1,6.2,2.19,12.615,12.615,0,0,1,4.665,4.38,12.769,12.769,0,0,1,1.8,7.1,11.7,11.7,0,0,1-1.971,6.57,13.645,13.645,0,0,1-5.432,4.665,17.521,17.521,0,0,1-7.863,1.73,20.39,20.39,0,0,1-7.4-1.27,20.5,20.5,0,0,1-5.453-3.154A26.282,26.282,0,0,1,0,36.733Z"
        transform="translate(0 0.004)"
      />
      <path
        fill="currentColor"
        d="M38.346,27.868l4.38,4.818a16.119,16.119,0,0,1-4.994,3.57,15.55,15.55,0,0,1-6.57,1.336A17.521,17.521,0,0,1,22.4,35.578a13.141,13.141,0,0,1-5.388-5.585,17.521,17.521,0,0,1-1.862-8.279,15.922,15.922,0,0,1,2.037-7.95A15.331,15.331,0,0,1,22.8,7.982a15.922,15.922,0,0,1,8.366-2.19,16.3,16.3,0,0,1,6.57,1.314,15.331,15.331,0,0,1,5.125,3.526L38.083,15.45a8.76,8.76,0,0,0-2.957-2.19,9.242,9.242,0,0,0-3.964-.832,7.885,7.885,0,0,0-4.731,1.336A8.169,8.169,0,0,0,23.585,17.2a11.367,11.367,0,0,0-.92,4.556,11.148,11.148,0,0,0,.92,4.38,8.432,8.432,0,0,0,2.8,3.548,7.622,7.622,0,0,0,4.731,1.4,9.79,9.79,0,0,0,4.1-.854,8.454,8.454,0,0,0,3.132-2.365Z"
        transform="translate(18.028 6.898)"
      />
      <path
        fill="currentColor"
        d="M28.61,42.9V.52h7.425V16.158a12.571,12.571,0,0,1,3.373-2.475,11.586,11.586,0,0,1,5.519-1.161,10.622,10.622,0,0,1,8.5,3.417,13.141,13.141,0,0,1,2.957,8.914V42.943H48.869V24.852a5.957,5.957,0,0,0-1.555-4.38,5.41,5.41,0,0,0-4.03-1.577,6.57,6.57,0,0,0-5.059,2.387,8.125,8.125,0,0,0-2.19,5.475V42.9Z"
        transform="translate(34.05 0.627)"
      />
      <path
        fill="currentColor"
        d="M59.938,5.809a12.856,12.856,0,0,1,9.505,3.526,12.987,12.987,0,0,1,3.526,9.571,19.711,19.711,0,0,1-2.19,9.461,17.521,17.521,0,0,1-6.2,6.768,16.426,16.426,0,0,1-9.089,2.519,13.623,13.623,0,0,1-6.833-1.665A11.564,11.564,0,0,1,44.1,31.368a14.192,14.192,0,0,1-1.621-6.943A18.792,18.792,0,0,1,43.84,17.2a19.186,19.186,0,0,1,3.723-5.957,17.061,17.061,0,0,1,5.585-3.986,16.229,16.229,0,0,1,6.789-1.445Zm-.986,6.351a7.534,7.534,0,0,0-4.38,1.511,11.7,11.7,0,0,0-4.928,9.68A9.527,9.527,0,0,0,51.265,29a5.738,5.738,0,0,0,4.994,2.3,7.885,7.885,0,0,0,4.38-1.445,10.951,10.951,0,0,0,3.636-3.9,12.155,12.155,0,0,0,1.38-5.913,9,9,0,0,0-1.621-5.672,5.913,5.913,0,0,0-5.081-2.212Z"
        transform="translate(50.555 6.902)"
      />
      <path
        fill="currentColor"
        d="M70.871,5.809a12.856,12.856,0,0,1,9.505,3.526A12.988,12.988,0,0,1,83.9,18.906a19.711,19.711,0,0,1-2.19,9.461,17.521,17.521,0,0,1-6.2,6.768,16.426,16.426,0,0,1-9.089,2.519,13.623,13.623,0,0,1-6.833-1.665,11.564,11.564,0,0,1-4.709-4.621,14.192,14.192,0,0,1-1.621-6.943A18.791,18.791,0,0,1,54.62,17.2a19.186,19.186,0,0,1,3.789-5.957,17.062,17.062,0,0,1,5.672-3.986,16.229,16.229,0,0,1,6.789-1.445Zm-.942,6.351a7.534,7.534,0,0,0-4.38,1.511,11.7,11.7,0,0,0-4.928,9.68A9.527,9.527,0,0,0,62.242,29a5.738,5.738,0,0,0,4.994,2.3,7.884,7.884,0,0,0,4.38-1.446,10.951,10.951,0,0,0,3.592-3.9,12.156,12.156,0,0,0,1.38-5.913,9,9,0,0,0-1.621-5.672A5.913,5.913,0,0,0,69.929,12.16Z"
        transform="translate(63.385 6.902)"
      />
      <path
        fill="currentColor"
        d="M68.41,42.9V.52H75.9V42.9Z"
        transform="translate(81.418 0.627)"
      />
      <path
        fill="currentColor"
        d="M73.78,8.4V.52h7.994V8.4ZM74.021,42.9V13.113h7.512V42.9Z"
        transform="translate(87.809 0.627)"
      />
      <path
        fill="currentColor"
        d="M83.151,43.518v-23.7H78.07V13.732h5.081v-1.84a12.352,12.352,0,0,1,1.73-6.943A10.1,10.1,0,0,1,89.13,1.183,11.958,11.958,0,0,1,94.211,0a20.653,20.653,0,0,1,4.512.569A11.432,11.432,0,0,1,103.5,3.11l-3.5,4.972A9.965,9.965,0,0,0,97.8,6.921a6.965,6.965,0,0,0-2.365-.35,4.577,4.577,0,0,0-3.526,1.424,5.957,5.957,0,0,0-1.292,4.1v1.73h9.418l2.8,6.089H90.663v23.61Z"
        transform="translate(92.914 0.008)"
      />
      <path
        fill="currentColor"
        d="M86.315,47.291l3.373-5.278a9.921,9.921,0,0,0,1.4.986,3.417,3.417,0,0,0,1.905.482,3.132,3.132,0,0,0,2.541-1.27,15.332,15.332,0,0,0,2.037-3.942l.942-2.409L85.11,6.27h8.761l8.5,20.39,7.512-20.39h8.191L105.61,36.056c-.591,1.445-1.183,2.957-1.8,4.556a26.279,26.279,0,0,1-2.19,4.38,10.447,10.447,0,0,1-3.154,3.263,8.563,8.563,0,0,1-4.884,1.27,11.7,11.7,0,0,1-4.336-.635,10.732,10.732,0,0,1-2.935-1.6Z"
        transform="translate(101.293 7.47)"
      />
      <circle
        fill="currentColor"
        cx="4.446"
        cy="4.446"
        r="4.446"
        transform="translate(109.091 17.902)"
      />
      <circle
        fill="currentColor"
        cx="4.446"
        cy="4.446"
        r="4.446"
        transform="translate(133.599 17.902)"
      />
    </svg>
  );
};

export default Logo;
